import { Directive, HostListener, inject, Input } from '@angular/core';
import { GoogleAnalyticsService } from '@lx/shared/google-analytics';
import { NavigationService } from '../services';
import { RouteIds } from '../types';

/**
 * Directive to handle navigation to a specific step in the quote tool. Every time there is a
 * navigation, the Google Analytics click event is tracked.
 */
@Directive({
  standalone: true,
  selector: '[lxNavigationToStep]',
})
export class NavigationToStepDirective {
  @Input() lxNavigationToStep: RouteIds | undefined;
  @Input() gaEvent: string | undefined;
  @Input() disabled: boolean | undefined;

  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);
  private readonly navigationService = inject(NavigationService);

  @HostListener('click', ['$event'])
  @HostListener('keydown.enter', ['$event'])
  onActivate(event: Event) {
    if (this.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (event instanceof MouseEvent) {
      this.googleAnalyticsService.trackClickEvent(this.gaEvent);
    }

    this.navigationService.navigateToStep(this.lxNavigationToStep);
    event.stopImmediatePropagation();
  }
}
